import { createFileRoute } from '@tanstack/react-router'
import DesignSystemPage from '../../app/design-system/page'

export const Route = createFileRoute('/_auth/design-system')({
  component: DesignSystemPage,
})
